export default __webpack_public_path__ + "static/cnp4-87418d8f916905c0da80fbe6cd80660f.png";